import { PricingTraditional } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/** Услуги и прайс с импортом (АДМ-02, АДМ-04; матрица 2.2 «Прайс, услуги, база знаний»: OWNER, MED_DIR, FRONT_DESK — изменение; OPS_DIR, DOCTOR — чтение). */
export const section = defineSection({
  id: 'schedule.services',
  area: 'clinic',
  path: 'services',
  roles: ['OWNER', 'MED_DIRECTOR', 'OPS_DIRECTOR', 'DOCTOR', 'FRONT_DESK'],
  icon: PricingTraditional,
  titleKey: 'services:title',
  namespaces: ['portal'],
  navGroup: 'bot',
  order: 11,
  navRoles: ['OWNER', 'MED_DIRECTOR', 'OPS_DIRECTOR', 'FRONT_DESK'],
  tabGroup: 'knowledge',
  load: () => import('./ServicesPage'),
});
